import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Flex,
    HStack,
    Text,
    VStack,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {InfoIcon} from '../icons'
import InfoPopover from '../popovers/info-popover'

const StoreBenefitCard = ({
    icon,
    benefitTitle,
    benefitSubtitle,
    infoPopoverTitle,
    infoPopoverDescription,
    urlLink,
    urlLinkId,
}) => {
    const styles = useMultiStyleConfig('StoreBenefitCard')

    const shouldRenderLink = urlLink && urlLink !== urlLinkId
    const shouldRenderInfoPopover = infoPopoverTitle || infoPopoverDescription

    return (
        <Box {...styles.card}>
            {icon}
            <Flex {...styles.textContainer}>
                <Flex {...styles.flexWithTooltip}>
                    <VStack {...styles.textContent}>
                        <HStack {...styles.titleRow}>
                            {shouldRenderLink ? (
                                <Box
                                    as="a"
                                    href={urlLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    {...styles.urlLink}
                                >
                                    <Text {...styles.titleText}>{benefitTitle}</Text>
                                </Box>
                            ) : (
                                <Text {...styles.titleText}>{benefitTitle}</Text>
                            )}

                            {shouldRenderInfoPopover ? (
                                <Box {...styles.infoPopBox}>
                                    <InfoPopover
                                        trigger={
                                            <InfoIcon {...styles.infoIcon} aria-label="More Info" />
                                        }
                                        title={infoPopoverTitle}
                                        description={infoPopoverDescription}
                                    />
                                </Box>
                            ) : null}
                        </HStack>

                        <Text {...styles.subtitleText}>{benefitSubtitle}</Text>
                    </VStack>
                </Flex>
            </Flex>
        </Box>
    )
}

StoreBenefitCard.propTypes = {
    icon: PropTypes.node,
    benefitTitle: PropTypes.node,
    benefitSubtitle: PropTypes.node,
    infoPopoverTitle: PropTypes.string,
    infoPopoverDescription: PropTypes.string,
    urlLink: PropTypes.string,
    urlLinkId: PropTypes.string,
}

export default StoreBenefitCard
